module.exports = __webpack_public_path__ + "img/pic_india_07.34131970.jpg";